import React from 'react';
import {
  DirectionsCar,
  Warning,
  Security,
  Handshake,
  Description,
  ShowChart,
  Notifications,
  SwapVert,
  BarChart,
  SmartToy,
  Search,
} from '@mui/icons-material';

interface BenefitItem {
  icon: React.ReactNode;
  text: string;
}

export const SUBSCRIBE_BENEFITS: BenefitItem[] = [
  {
    icon: <DirectionsCar sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'VIN Lookups',
  },
  {
    icon: <Warning sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Accident** & Salvage Lookups',
  },
  {
    icon: <Security sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Theft Records Lookups',
  },
  {
    icon: <Handshake sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Sales & Background Searches',
  },
  {
    icon: <Warning sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Title Checks',
  },
  {
    icon: <Description sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Specifications & Equipment Details',
  },
  {
    icon: <ShowChart sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'Market Values & Ownership Cost',
  },
  {
    icon: <Search sx={{ fontSize: 24, color: 'text.secondary' }} />,
    text: 'MULTIPLE Ways to Search. Search by VIN, License Plate, and Model',
  },
];

export const SUBSCRIPTION_PLAN_UNIQUE_NAME =
  '7_day_trial_1_00_up_front_27_99_recurring_monthly_freshness_limit_50_no_pdf_vehicle_bumper_upsell';

export const PLAN_DISPLAY = {
  setupPrice: '$1.00',
  recurringPrice: '$27.99',
  trialPeriod: '7',
  monthlyLimit: '50',
  totalToday: '$1.00',
  recurringText: 'Then $27.99/month',
};
